import script from "./SkillComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillComponent.vue?vue&type=script&setup=true&lang=js"

import "./SkillComponent.vue?vue&type=style&index=0&id=2786fdf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2786fdf8"]])

export default __exports__